import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

import { contentVariants, modalVariants } from './DefaultModal.const';
import styles from './DefaultModal.module.scss';

export type IDefaultModal = {
  onClose?: () => void;
  children?: React.ReactNode;
  show?: boolean;
  isBackgroundContainers?: boolean;
  backgroundContent?: string;
  typeContents?: 'long' | 'small';
};

const DefaultModal: React.FC<IDefaultModal> = ({
  onClose,
  children,
  show,
  isBackgroundContainers = true,
  backgroundContent = 'rgba(14, 13, 13, 0.95)',
  typeContents = 'small'
}) => {
  return (
    <AnimatePresence>
      {show && (
        <>
          <motion.div
            key={'shadow'}
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className={styles['drop-shadow']}
            style={{
              background: isBackgroundContainers ? '#0B111EBF' : 'unset'
            }}
            onClick={onClose}
            data-testid="modal-content"
          />
          <motion.div
            key={'content'}
            variants={contentVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            style={{
              background: backgroundContent
            }}
            className={
              typeContents === 'small'
                ? styles['content-container']
                : styles['content-container-long-contents']
            }
          >
            <div className={styles['content-wrapper']}>{children}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default DefaultModal;
